// extracted by mini-css-extract-plugin
export default {"description":"TargetGroupForm_description__WkDcu"};